var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.media)?_c('div',_vm._b({staticClass:"media--backdrop"},'div',_vm.$vefa.element,false),[_c('img',_vm._b({attrs:{"alt":_vm.alt,"src":require(("@res/" + _vm.media))}},'img',_vm.$vefa.media,false))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }